import { createFileRoute, Outlet } from '@tanstack/react-router';
import type { JSX } from 'react';

import { canAccessCustomerPortal } from '@/shared/permissions/pagePermissions';
import type { PageStaticData } from '@/shared/routing';

// The customer portal: the pages a Customer user may open, and only those (MAN-2864). Its access gates every page
// below, so they may assume a customer. It draws nothing itself: each page picks its navbar with its own `chrome`.
export const Route = createFileRoute('/_authenticated/customer-portal')({
    staticData: { access: { permissions: canAccessCustomerPortal }, chrome: 'none' } satisfies PageStaticData,
    component: RouteComponent,
});

function RouteComponent(): JSX.Element {
    return <Outlet />;
}
